import { categories } from './comics';

export interface CategoryPageData {
  slug: string;
  name: string;
  icon: string;
  count: number;
  description: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
}

export function getCategoryBySlug(slug: string): CategoryPageData | undefined {
  const cat = categories.find(c => c.slug === slug);
  if (!cat) return undefined;

  const seoData: Record<string, { title: string; description: string; keywords: string }> = {
    rexue: {
      title: '热血韩漫 - 免费在线阅读热血韩国漫画 - 韩国漫画网',
      description: '韩国漫画网热血韩漫分类，提供最新热血战斗类韩国漫画免费在线阅读。海量热血韩漫资源每日同步更新，热血、战斗、冒险题材一网打尽。',
      keywords: '热血韩漫,热血漫画,战斗漫画,韩国热血漫画,免费热血漫画',
    },
    lianai: {
      title: '恋爱韩漫 - 免费在线阅读恋爱韩国漫画 - 韩国漫画网',
      description: '韩国漫画网恋爱韩漫分类，提供最新恋爱甜蜜类韩国漫画免费在线阅读。浪漫爱情韩漫每日更新，涵盖校园恋爱、都市爱情等多种题材。',
      keywords: '恋爱韩漫,恋爱漫画,爱情漫画,韩国恋爱漫画,免费恋爱漫画',
    },
    xiaoyuan: {
      title: '校园韩漫 - 免费在线阅读校园韩国漫画 - 韩国漫画网',
      description: '韩国漫画网校园韩漫分类，提供最新校园青春类韩国漫画免费在线阅读。青春校园韩漫每日更新，记录校园生活的欢笑与成长。',
      keywords: '校园韩漫,校园漫画,青春漫画,韩国校园漫画,免费校园漫画',
    },
    qihuan: {
      title: '奇幻韩漫 - 免费在线阅读奇幻韩国漫画 - 韩国漫画网',
      description: '韩国漫画网奇幻韩漫分类，提供最新奇幻冒险类韩国漫画免费在线阅读。魔法、异世界、冒险题材韩漫每日同步更新。',
      keywords: '奇幻韩漫,奇幻漫画,冒险漫画,韩国奇幻漫画,免费奇幻漫画',
    },
    xuanyi: {
      title: '悬疑韩漫 - 免费在线阅读悬疑韩国漫画 - 韩国漫画网',
      description: '韩国漫画网悬疑韩漫分类，提供最新悬疑推理类韩国漫画免费在线阅读。烧脑悬疑韩漫每日更新，层层谜团让你欲罢不能。',
      keywords: '悬疑韩漫,悬疑漫画,推理漫画,韩国悬疑漫画,免费悬疑漫画',
    },
    gaoxiao: {
      title: '搞笑韩漫 - 免费在线阅读搞笑韩国漫画 - 韩国漫画网',
      description: '韩国漫画网搞笑韩漫分类，提供最新搞笑幽默类韩国漫画免费在线阅读。轻松搞笑韩漫每日更新，欢乐不断笑点满满。',
      keywords: '搞笑韩漫,搞笑漫画,幽默漫画,韩国搞笑漫画,免费搞笑漫画',
    },
    dongzuo: {
      title: '动作韩漫 - 免费在线阅读动作韩国漫画 - 韩国漫画网',
      description: '韩国漫画网动作韩漫分类，提供最新动作格斗类韩国漫画免费在线阅读。热血动作韩漫每日同步更新，精彩对决不容错过。',
      keywords: '动作韩漫,动作漫画,格斗漫画,韩国动作漫画,免费动作漫画',
    },
    richang: {
      title: '日常韩漫 - 免费在线阅读日常韩国漫画 - 韩国漫画网',
      description: '韩国漫画网日常韩漫分类，提供最新日常治愈类韩国漫画免费在线阅读。温馨日常韩漫每日更新，治愈你的每一天。',
      keywords: '日常韩漫,日常漫画,治愈漫画,韩国日常漫画,免费日常漫画',
    },
  };

  const seo = seoData[slug] || {
    title: `${cat.name}韩漫 - 免费在线阅读${cat.name}韩国漫画 - 韩国漫画网`,
    description: `韩国漫画网${cat.name}韩漫分类，海量${cat.name}韩国漫画免费在线阅读，每日同步更新。`,
    keywords: `${cat.name}韩漫,韩国${cat.name}漫画,免费${cat.name}漫画`,
  };

  return {
    ...cat,
    seoTitle: seo.title,
    seoDescription: seo.description,
    seoKeywords: seo.keywords,
  };
}